"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceInputState = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const lodash_1 = require("lodash");
const mobx_1 = require("mobx");
const input_state_1 = require("./input.state");
const number_input_state_1 = require("./number.input.state");
class DistanceInputState extends input_state_1.InputState {
    static equal(value1, value2) {
        const inches1 = DistanceInputState.metersAsInches(value1);
        const inches2 = DistanceInputState.metersAsInches(value2);
        return number_input_state_1.NumberInputState.equal(inches1, inches2, DistanceInputState.INCH_PRECISION);
    }
    static metersAsInches(value) {
        return core_shared_1.IkeUnit.round(core_shared_1.IkeUnit.convert(value, core_shared_1.IkeUnit.INCH, core_shared_1.IkeUnit.METER), number_input_state_1.NumberInputState.DEFAULT_PRECISION);
    }
    constructor(label) {
        super(label);
        this.isLabelShown = false;
        const debounceMetric = (0, lodash_1.debounce)(() => this.updateMetric(), 600);
        const debounceImperial = (0, lodash_1.debounce)(() => this.updateImperial(), 600);
        const metricOptions = {
            onblur: () => debounceMetric.flush(),
            oninput: () => debounceMetric(),
        };
        const imperialOptions = {
            onblur: () => debounceImperial.flush(),
            oninput: () => debounceImperial(),
        };
        this.meters = new number_input_state_1.NumberInputState('m', DistanceInputState.METER_PRECISION, undefined, metricOptions);
        this.feet = new number_input_state_1.NumberInputState('ft', undefined, undefined, imperialOptions);
        this.inch = new number_input_state_1.NumberInputState('in', DistanceInputState.INCH_PRECISION, undefined, imperialOptions);
        this.meters.isLabelShown = false;
        this.feet.isLabelShown = false;
        this.inch.isLabelShown = false;
        this.meters.hideZero = true;
        this.feet.hideZero = true;
        this.inch.hideZero = true;
    }
    setValue(meters) {
        this._value = meters;
        if (this.value == null || isNaN(this.value)) {
            this.meters.setValue(null);
            this.feet.setValue(null);
            this.inch.setValue(null);
            return;
        }
        const inches = DistanceInputState.metersAsInches(this.value);
        const feetInch = core_shared_1.IkeUnit.splitFeetInch(inches);
        if (feetInch.feet !== this.feet.value) {
            this.feet.setValue(feetInch.feet !== 0 ? feetInch.feet : null);
        }
        if (feetInch.inches !== this.inch.value) {
            this.inch.setValue(feetInch.inches !== 0 ? feetInch.inches : null);
        }
        this.meters.setValue(this.value !== 0 ? this.value : null);
    }
    hasError() {
        return this.meters.hasError() || this.feet.hasError() || this.inch.hasError();
    }
    updateImperial() {
        if (this.hasError()) {
            return;
        }
        if (this.feet.value == null && this.inch.value == null) {
            this.setValue(null);
        }
        else {
            const inches = core_shared_1.IkeUnit.joinFeetInch(this.feet.value || 0, this.inch.value || 0);
            const meters = core_shared_1.IkeUnit.convert(inches, core_shared_1.IkeUnit.METER, core_shared_1.IkeUnit.INCH);
            this.setValue(meters);
        }
    }
    updateMetric() {
        if (this.hasError()) {
            return;
        }
        this.setValue(this.meters.value);
    }
    set isAutoFocused(isFocus) {
        if (this.feet == null) {
            return;
        }
        this.meters.isAutoFocused = isFocus;
        this.feet.isAutoFocused = isFocus;
    }
    get isAutoFocused() {
        return this.meters.isAutoFocused;
    }
}
exports.DistanceInputState = DistanceInputState;
DistanceInputState.METER_PRECISION = 3;
DistanceInputState.INCH_PRECISION = 1;
tslib_1.__decorate([
    mobx_1.action
], DistanceInputState.prototype, "setValue", null);
tslib_1.__decorate([
    mobx_1.action.bound
], DistanceInputState.prototype, "updateImperial", null);
tslib_1.__decorate([
    mobx_1.action.bound
], DistanceInputState.prototype, "updateMetric", null);
//# sourceMappingURL=distance.input.state.js.map